import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import useGroupedAssets from "./hooks/useGroupedAssets";
import GroupedAssetTable from "./GroupedAssetTable";
import SearchAndExport from "./SearchAndExport";
import ActiveFilterChips from "../../ActiveFilterChips";
import { GROUP_VIEW_FILTER_PARAMS } from "./groupViewParams";

const styles = {
  dialogTitle: {
    m: 0,
    p: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  },
  closeButton: {
    position: "absolute",
    right: 8,
    top: 8,
  },
  dialogContent: {
    maxHeight: "70vh",
    overflow: "visible",
  },
};

export default function GroupedAssetViewModal({ project, projectId, onClose }) {
  const {
    collection,
    initialLoading,
    loading,
    searchLoading,
    error,
    hasNextPage,
    search,
    handleSearch,
    handleScroll,
  } = useGroupedAssets(projectId);

  return (
    <Dialog open onClose={onClose} maxWidth="md" fullWidth disableEnforceFocus>
      <DialogTitle sx={styles.dialogTitle}>
        <Box>
          <Typography fontWeight={500} fontSize={18} color="text.primary" align="center">
            Grouped Asset View for
          </Typography>
          <Typography fontWeight={500} fontSize={18} color="text.secondary" align="center">
            {project?.name}
          </Typography>
        </Box>
        <IconButton aria-label="close" onClick={onClose} sx={styles.closeButton}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={styles.dialogContent}>
        <ActiveFilterChips
          sx={{ pb: 0.5 }}
          paramKeys={GROUP_VIEW_FILTER_PARAMS}
          inventoryFromParams
        />
        <SearchAndExport
          projectId={projectId}
          onSearch={handleSearch}
          searchLoading={searchLoading}
        />
        {error && (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
            <Typography color="error">Error loading grouped assets: {error.message}</Typography>
          </Box>
        )}
        <GroupedAssetTable
          collection={collection}
          projectId={projectId}
          initialLoading={initialLoading}
          loading={loading}
          hasNextPage={hasNextPage}
          onScroll={handleScroll}
        />
        {!initialLoading && collection.length === 0 && (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
            <Typography variant="body1" color="textSecondary">
              {search ? `No grouped assets found matching "${search}".` : "No grouped assets found"}
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} variant="outlined">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
